import React, { useEffect, useState, useRef} from 'react' 
import { Link, Route, Routes } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import i18n from './i18n'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHeart, faL } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios';
import Slider from 'react-slick'
import { useAuth } from './AuthContext';
import '../layout/AreaPessoal.Module.css'
import Cookies from 'js-cookie';  // Importe a biblioteca js-cookie

export const addToRecentView = (productId) => {
  let recentViews = Cookies.get('recentViews');
  recentViews = recentViews ? JSON.parse(recentViews) : [];

  // Converta o ID para string para consistência
  productId = String(productId);

  // Remova o produto se ele já existir na lista para evitar duplicatas
  recentViews = recentViews.filter(id => id !== productId);

  // Adicione o produto no início da lista
  recentViews.unshift(productId);

  // Limite a lista a 8 itens
  if (recentViews.length > 8) {
    recentViews = recentViews.slice(0, 8);
  }
  // Atualize os cookies
  Cookies.set('recentViews', JSON.stringify(recentViews), { expires: 7 }); // Armazena por 7 dias
};

function AreaPessoal() {
  const { user, logout, toggleFavorite  } = useAuth();
  console.log(user);

  const [favoriteProducts, setFavoriteProducts] = useState([]);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage] = useState('');

  const navigate = useNavigate();
  const GotToNewPage =(nome,id)=>{
    if (typeof nome !== 'string' || !nome.trim()) {
      console.error("Erro: 'nome' está indefinido ou não é uma string válida:", nome);
      return;
    }
    const url = `/prodetail/${encodeURIComponent(nome.replace(/\s+/g, '-').toLowerCase())}/${id}`;
    window.open(url, '_blank');
  }

  const twoFunctions =(nome,id)=>{
    addToRecentView(id)
    GotToNewPage(nome,id)
  }

  const { t, i18n } = useTranslation('');
  const [display, setDisplay] = useState(true);
  const [width, setWidth] = useState(600);

  const favor = {
    autoplay: false,
    dots: false,
    infinite: false,
    arrow: false,
    slidesToShow: Math.min(6, favoriteProducts.length),
    slidesToScroll: Math.min(6, favoriteProducts.length),
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: Math.min(5, favoriteProducts.length),
          slidesToScroll: Math.min(5, favoriteProducts.length),
          dots: true,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: Math.min(3, favoriteProducts.length),
          slidesToScroll: Math.min(3, favoriteProducts.length),
          dots: false,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
        }
      }
    ]
  };

  useEffect(() => {
    // Adiciona uma classe ao body quando o componente for montado
    document.body.classList.add('backgroundImage2');

    // Limpa a classe quando o componente for desmontado
    return () => {
        document.body.classList.remove('backgroundImage2');
    };
}, []);  // O array vazio [] garante que isso ocorra apenas uma vez

  return (
  <div className='container area-pessoal'>

    <div className="container first-block">
        <section id="Profile" className='mb-5 row'>

          <div id="user" className="text-center col-sm-8 col-xl-7">
            <div id="img" />
            <div id="name">
              <h2>{t('apessoal.welcome')}: {user?.nome || 'Usuário'}</h2>
              <h5>{user?.email} </h5>
            </div>
          </div>
        </section>

    <div className="container recomented-prods mb-4">

    {favoriteProducts.length > 0 && (
      <h5 className='glow'>{t('pdetail.titleFavor')}</h5>
    )}
    <div className='row'>
    {favoriteProducts.length > 0 ? (  // Verificando se há produtos
          favoriteProducts.length > 5 ? (  // Verificando se há mais de 5 produtos
            <div className="slider-container mt-5">
          <Slider {...favor}>
          {favoriteProducts.map((resu, index) => (
           <div className="col-sm-6 col-md-2" key={index}>
           <div className="shop__thumb">
                      {/* Exibe "Novidade" se o produto for novo */}
                      {resu.novo === 1 && <h6 className='novidades-button'>{t('listProds.novo')}</h6>}

                      {/* Botão de favorito, visível apenas para usuários logados */}
                      {user && (
                        <button className="favorite-btn" onClick={() => toggleFavorite(resu)}>
                          {user?.favorites?.some(fav => fav.idP === resu.idP) ? (
                            <FontAwesomeIcon icon={faHeart} size={24} color="red" />
                          ) : (
                            <FontAwesomeIcon icon={faHeart} size={24} color="gray" />
                          )}
                        </button>
                      )}
                      <Link to={`/prodetail/${encodeURIComponent(resu.nome.replace(/\s+/g, '-').toLowerCase())}/${resu.idP}`}
                        target="_blank" onClick={() => addToRecentView(resu.idP)}>
                        <div className="shop-thumb__img">
                          <img src={resu.imgP} className="img-responsive" alt={resu.nome} />
                        </div>
                        <h3 className="shop-thumb__title translate pnome"><b>{resu.nome}</b></h3>
                        <h5 className="shop-thumb-brand b-name">{resu.marca}</h5> 
                        {/* Exibição das Referências */}
                        <h5 className="shop-thumb-brand ref-pvp">
                          <div className='ref-block'>
                            <span className="references">Ref:</span>&nbsp;
                            {resu.prodEspe}
                          </div>
                          <div className='pvp-text'>
                            <span className="pvp-value">{typeof resu.pvp === "number" ? <span className="references">P.V.P.</span> : ""}</span>
                          </div>
                        </h5>

                        {/* Exibição do IP e do preço PVP */}
                        <div className="ip-pvp-container">
                        {resu?.ip != null ? (
                        <span className="shop-thumb-brand second-block">
                              <span className="no-bold">IP {resu.ip}</span>
                        </span> ): <span  className='no-ip'> </span>}
                          <span className="pvp-value">{typeof resu.pvp === "number" ? `${resu.pvp.toFixed(2)}€` : ""}</span>
                        </div>
                      </Link>
                    </div>
                 </div>
              ))}
            </Slider>
            </div>
          ) : (
            // Caso tenha 5 ou menos produtos, exibe-os normalmente
            favoriteProducts.map((resu, index) => (
              <div className="col-sm-6 col-md-3 col-xl-2" key={index}>
                    <div className="shop__thumb">
                      {/* Exibe "Novidade" se o produto for novo */}
                      {resu.novo === 1 && <h6 className='novidades-button'>{t('listProds.novo')}</h6>}

                      {/* Botão de favorito, visível apenas para usuários logados */}
                      {user && (
                        <button className="favorite-btn" onClick={() => toggleFavorite(resu)}>
                          {user?.favorites?.some(fav => fav.idP === resu.idP) ? (
                            <FontAwesomeIcon icon={faHeart} size={24} color="red" />
                          ) : (
                            <FontAwesomeIcon icon={faHeart} size={24} color="gray" />
                          )}
                        </button>
                      )}
                      <Link to={`/prodetail/${encodeURIComponent(resu.nome.replace(/\s+/g, '-').toLowerCase())}/${resu.idP}`}
                        target="_blank" onClick={() => addToRecentView(resu.idP)}>
                        <div className="shop-thumb__img">
                          <img src={resu.imgP} className="img-responsive" alt={resu.nome} />
                        </div>
                        <h3 className="shop-thumb__title translate pnome"><b>{resu.nome}</b></h3>
                        <h5 className="shop-thumb-brand b-name">{resu.marca}</h5> 
                        {/* Exibição das Referências */}
                        <h5 className="shop-thumb-brand ref-pvp">
                          <div className='ref-block'>
                            <span className="references">Ref:</span>&nbsp;
                            {resu.prodEspe}
                          </div>
                          <div className='pvp-text'>
                            <span className="pvp-value">{typeof resu.pvp === "number" ? <span className="references">P.V.P.</span> : ""}</span>
                          </div>
                        </h5>

                        {/* Exibição do IP e do preço PVP */}
                        <div className="ip-pvp-container">
                          {resu?.ip != null && (
                            <span className="shop-thumb-brand second-block">
                              <span className="no-bold">IP {resu.ip}</span>
                            </span>
                          )}
                          <span className="pvp-value">{typeof resu.pvp === "number" ? `${resu.pvp.toFixed(2)}€` : ""}</span>
                        </div>
                      </Link>
                    </div>
              </div>

            ))
          )
        ) : (
          <h5 className='title-related'>{t('apessoal.txtnoFavor')}</h5>
        )}
     </div>
    </div>
   </div>

   </div>
  )
}
export default AreaPessoal

